import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/_services/breadcrumb.service';

@Component({
    selector: 'app-options-requisition-note',
    templateUrl: './options-requisition-note.component.html',
    styleUrls: ['./options-requisition-note.component.scss'],
    standalone: false
})
export class OptionsRequisitionNoteComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  mode: any;
  parentType: any;
  redirectUrl: string='dashboard/inventory/global-requisition';

  constructor(
    private util: UtilServiceService,
    private languageTranslateService: LanguageTranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumb: BreadcrumbService
  ) { 
    super();
   
  }

  ngOnInit(): void {
    if (this.route.snapshot.data["mode"]) {
      this.mode = this.route.snapshot.data["mode"];
    }
    //this.requestType = this.route.snapshot.queryParams['requestType'] || 'none';
    this.parentType = this.route.snapshot.data['parentType'] || 'none';
    if(this.parentType == 'consignment'){
      this.redirectUrl= 'dashboard/inventory/global-consignment'
    }
    this.route.queryParams.subscribe(params => {
     
    });

    this.getLanguageData();
  }
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.loadBreadCrum();
         
        }
      })
    );
  }
  loadBreadCrum() {
    console.log(this.mode, "===mode", this.parentType)
    if(this.parentType == 'consignment'){
    this.breadcrumb.setItems([
      { label: this.translate?.consignment.label.plural, routerLink: ["/dashboard/inventory/global-consignment/all"] },
      { label: this.mode == "add" ?  this.translate?.general.buttons.new.singular + " " +this.translate?.consignment.label.singular :  this.translate?.general.buttons.edit.singular + " " +this.translate?.consignment.label.singular },
    ]);
  }else{
    this.breadcrumb.setItems([
      { label: this.translate?.requisition.label.plural, routerLink: ["/dashboard/inventory/global-requisition/all"] },
      { label: this.mode == "add" ?  this.translate?.general.buttons.new.singular + " " +this.translate?.requisition.label.singular :  this.translate?.general.buttons.edit.singular + " " +this.translate?.requisition.label.singular },
    ]);
  }
  }
  goBack(){
    this.router.navigate([this.redirectUrl+'/all']);
  }
  
  onSelectTypeChange(type: any) {

    console.log('Selected Type:', type);
    // Perform actions based on the selected type
    // For example, navigate to a different route or update the UI
    if(type == 'asset' ){
      this.router.navigate([this.redirectUrl+'/selectionAsset']);
    }else if(type == 'sparePart' ){
      this.router.navigate([this.redirectUrl+'/selectionSparePart']);
    }else{
      this.router.navigate([this.redirectUrl+'/custom']);
    }
   

  }


}
